export function dataInRequest(params = {}) {
  return {
    type: '@unidadeSaldoCota/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@unidadeSaldoCota/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@unidadeSaldoCota/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@unidadeSaldoCota/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@unidadeSaldoCota/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@unidadeSaldoCota/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@unidadeSaldoCota/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@unidadeSaldoCota/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@unidadeSaldoCota/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@unidadeSaldoCota/RECORD_FILTERING',
    payload: { params },
  };
}
